import {load} from '@shopify/theme-sections';

// import '../sections/featured-collection-slider';
import '../sections/collection-page';
// import '../sections/swatch';

import Ymal from '../sections/ymal-collection';
import Filter from '../sections/filter';

if (document.body.classList.contains('template-collection')) {
  Filter().init();
  Ymal().init();

  load('*');
}
